import React, { useState } from 'react';
import theme from '../../../theme/globalTheme';
import { Table, Button, Drawer, Space, Tag, Form, Input, DatePicker, TimePicker, InputNumber, Select, Switch } from 'antd';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';

const { Option } = Select;

const YachtContract = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [form] = Form.useForm();

  const boats = {
    sxm: {
      day: {
        searay42: { name: 'Searay 42ft', price: 1600, peakPrice: 2130 },
        sunseeker53: { name: 'Sunseeker 53ft', price: 1900, peakPrice: 4070 },
        vandutch55: { name: 'Vandutch 55ft', price: 2100, peakPrice: 4840 },
        axopar45: { name: 'Axopar 45ft', price: 2100, peakPrice: 4100 },
        princess55: { name: 'Princess 55ft', price: 2700, peakPrice: 5500 },
        sunseeker68: { name: 'Sunseeker 68ft', price: 3000, peakPrice: 6250 },
        princess69: { name: 'Princess 69ft', price: 3100, peakPrice: 6320 },
        princess72: { name: 'Princess 72ft', price: 3800, peakPrice: 8570 },
        mochi74: { name: 'Mochi 74ft', price: 4000, peakPrice: 8790 },
      },
      night: {
        searay42: { name: 'Searay 42ft', price: 1900, peakPrice: 2130 },
        sunseeker53: { name: 'Sunseeker 53ft', price: 2300, peakPrice: 4070 },
        vandutch55: { name: 'Vandutch 55ft', price: 2500, peakPrice: 4840 },
        axopar45: { name: 'Axopar 45ft', price: 2400, peakPrice: 4100 },
        princess55: { name: 'Princess 55ft', price: 3200, peakPrice: 5500 },
        sunseeker68: { name: 'Sunseeker 68ft', price: 3500, peakPrice: 6250 },
        princess69: { name: 'Princess 69ft', price: 3600, peakPrice: 6320 },
        princess72: { name: 'Princess 72ft', price: 4600, peakPrice: 8570 },
        mochi74: { name: 'Mochi 74ft', price: 4800, peakPrice: 8790 },
      }
    },
    axa: {
      searay42: { name: 'Searay 42ft', price: 2100, peakPrice: 2130 },
      sunseeker53: { name: 'Sunseeker 53ft', price: 2500, peakPrice: 4070 },
      axopar45: { name: 'Axopar 45ft', price: 3500, peakPrice: 4100 },
      fiart54: { name: 'Fiart 54ft', price: 4000, peakPrice: 5840 },
      vandutch55: { name: 'Vandutch 55ft', price: 3000, peakPrice: 4840 },
      princess55: { name: 'Princess 55ft', price: 3600, peakPrice: 5500 },
      sunseeker68: { name: 'Sunseeker 68ft', price: 4500, peakPrice: 6250 },
      princess69: { name: 'Princess 69ft', price: 4600, peakPrice: 6320 },
      princess72: { name: 'Princess 72ft', price: 5900, peakPrice: 8570 },
      mochi74: { name: 'Mochi 74ft', price: 6400, peakPrice: 8790 },
    }
  };

  const StatusCell = ({ status, onEdit }) => (
    <Space>
      <Tag color={status === 'done' ? 'green' : 'orange'}>
        {status === 'done' ? 'Completed' : 'Pending'}
      </Tag>
      <Button
        icon={<EditOutlined />}
        size="small"
        onClick={onEdit}
      />
    </Space>
  );

  const cruisingOptions = [
    'Full Day around Saint Barth 9am - 5pm',
    'Full Day around Pinel 9am - 5pm',
    'Full Day around Anguilla 9am - 5pm',
    'Half Day around Saint Barth 9am - 1pm',
    'Half Day around Saint Barth 1pm - 5pm',
    'Half Day around St Barth + Sunset 1pm - 7pm',
    'Sunset around Saint Barth',
    'Transfer from St Martin to St Barth',
    'Transfer from St Barth to St Martin',
    'Transfer from Anguilla to St Barth',
    'Transfer from St Barth to Anguilla'
  ];

  const columns = [
    {
      title: 'Date du Charter',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Nom du client',
      dataIndex: 'client',
      key: 'client',
    },
    {
      title: 'Contrat',
      dataIndex: 'contractStatus',
      key: 'contract',
      render: (status) => (
        <StatusCell
          status={status}
          onEdit={() => console.log('Edit contract')}
        />
      ),
    },
    {
      title: 'Confirmation',
      dataIndex: 'confirmationStatus',
      key: 'confirmation',
      render: (status) => (
        <StatusCell
          status={status}
          onEdit={() => console.log('Edit confirmation')}
        />
      ),
    },
    {
      title: 'Facturation',
      dataIndex: 'billingStatus',
      key: 'billing',
      render: (status) => (
        <StatusCell
          status={status}
          onEdit={() => console.log('Edit billing')}
        />
      ),
    },
  ];

  const dummyData = [
    {
      key: '1',
      date: '19/02/24',
      client: 'Dawson',
      contractStatus: 'done',
      confirmationStatus: 'done',
      billingStatus: 'pending'
    },
    {
      key: '2',
      date: '20/02/24',
      client: '6 JULY',
      contractStatus: 'done',
      confirmationStatus: 'pending',
      billingStatus: 'pending'
    }
  ];

  const isPeakSeason = (dateString) => {
    if (!dateString) return false;
    const date = new Date(dateString);
    const month = date.getMonth();
    const day = date.getDate();
    if (month === 11 && day >= 22) return true;
    if (month === 0 && day <= 7) return true;
    return false;
  };

  const getVIPPrice = (persons, isNight) => {
    const dayPrices = {
      1: 220, 2: 310, 3: 470, 4: 560, 5: 680, 6: 770, 7: 1010,
      8: 1100, 9: 1200, 10: 1220, 11: 1290, 12: 1390, 13: 1460,
      14: 1540, 15: 1610
    };
    const nightPrices = {
      1: 255, 2: 360, 3: 540, 4: 640, 5: 850, 6: 890, 7: 1200,
      8: 1270, 9: 1380, 10: 1480, 11: 1380, 12: 1600, 13: 1680,
      14: 1770, 15: 1850
    };
    return isNight ? nightPrices[persons] || nightPrices[15] : dayPrices[persons] || dayPrices[15];
  };

  const calculatePrice = (values) => {
    const { charterDate, numberOfGuests, timeFrom, destination, boatType, boatPrice } = values;

    const isNight = timeFrom && (
      parseInt(timeFrom.format('HH')) >= 18 ||
      parseInt(timeFrom.format('HH')) < 6
    );

    const basePrice = boatPrice || 0;
    const vipPrice = numberOfGuests ? getVIPPrice(numberOfGuests, isNight) : 0;
    const sxmTaxes = 200;
    const sbhTaxes = numberOfGuests ? numberOfGuests * 5 : 0;
    const totalTaxes = sxmTaxes + sbhTaxes;

    return {
      basePrice,
      vipPrice,
      sxmTaxes,
      sbhTaxes,
      totalTaxes,
      totalPrice: basePrice + vipPrice + totalTaxes
    };
  };

  const onValuesChange = (changedValues, allValues) => {
    const prices = calculatePrice(allValues);
    form.setFieldsValue({
      boatPrice: prices.basePrice,
      vipService: prices.vipPrice,
      sxmTaxes: prices.sxmTaxes,
      sbhTaxes: prices.sbhTaxes,
      totalTaxes: prices.totalTaxes,
      totalPrice: prices.totalPrice
    });
  };

  const handleChange = (field, value) => {
    form.setFieldValue(field, value);
  };

  const ContractForm = () => (
    <Form
      form={form}
      layout="vertical"
      onValuesChange={onValuesChange}
      className="overflow-y-auto max-h-[calc(100vh-120px)]"
    >
      <div className="grid grid-cols-2 gap-4">
        <Form.Item name="clientName" label="Name of client" required>
          <Input />
        </Form.Item>
        <Form.Item name="vesselName" label="Name of Vessel" required>
          <Input />
        </Form.Item>
        <Form.Item name="billingNumber" label="Billing Number">
          <Input />
        </Form.Item>
        <Form.Item name="brandOfVessel" label="Brand of Vessel" required>
          <Input />
        </Form.Item>
        <Form.Item name="length" label="Length" required>
          <InputNumber className="w-full" min={0} />
        </Form.Item>
        <Form.Item name="placeOfDelivery" label="Place of delivery" required>
          <Input />
        </Form.Item>
        <Form.Item name="reservationDate" label="Reservation date" required>
          <DatePicker
            className="w-full"
            onChange={(date, dateString) => {
              const adjustedDate = date ? date.add(1, 'day') : null;
              handleChange('date', adjustedDate ? adjustedDate.format('YYYY-MM-DD') : '');
            }}
          />
        </Form.Item>
        <Form.Item name="charterDate" label="Charter Date" required>
          <DatePicker
            className="w-full"
            onChange={(date, dateString) => {
              const adjustedDate = date ? date.add(1, 'day') : null;
              handleChange('date', adjustedDate ? adjustedDate.format('YYYY-MM-DD') : '');
            }}
          />
        </Form.Item>
        <Form.Item name="timeFrom" label="From">
          <TimePicker className="w-full" format="HH:mm" />
        </Form.Item>
        <Form.Item name="timeTo" label="To">
          <TimePicker className="w-full" format="HH:mm" />
        </Form.Item>
        <Form.Item name="numberOfGuests" label="Number of guests" required>
          <InputNumber className="w-full" min={1} />
        </Form.Item>
        <Form.Item name="flightNumber" label="Flight Number">
          <Input />
        </Form.Item>
        <Form.Item name="takeOffTime" label="Take Off Time">
          <TimePicker className="w-full" format="HH:mm" />
        </Form.Item>
        <Form.Item name="cruisingArea" label="Cruising area" required>
          <Select>
            {cruisingOptions.map(option => (
              <Option key={option} value={option}>{option}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="vipServiceType" label="VIP Service Type">
          <Select>
            <Option value="">No VIP Service</Option>
            <Option value="taxi">Taxi Service</Option>
            <Option value="van">Van Service</Option>
          </Select>
        </Form.Item>
        <Form.Item name="boatPrice" label="Boat Price" required>
          <InputNumber className="w-full" min={0} />
        </Form.Item>
        <Form.Item name="vipServicePrice" label="VIP Service">
          <InputNumber className="w-full" disabled />
        </Form.Item>
        <Form.Item name="isNightService" label="Night Service" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item name="facturated" label="Facturated" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item name="sxmTaxes" label="SXM TAXES">
          <InputNumber className="w-full" disabled defaultValue={200} />
        </Form.Item>
        <Form.Item name="sbhTaxes" label="SBH TAXES">
          <InputNumber className="w-full" disabled />
        </Form.Item>
        <Form.Item name="totalTaxes" label="Total Taxes">
          <InputNumber className="w-full" disabled />
        </Form.Item>
        <Form.Item name="totalPrice" label="Total Price">
          <InputNumber className="w-full" disabled />
        </Form.Item>
        <Form.Item name="additionalInfos" label="Additional Infos">
          <Input.TextArea rows={2} />
        </Form.Item>
      </div>
      <Button type="primary" className="w-full">Submit</Button>
    </Form>
  );

  return (
    <div style={{ minHeight: '100vh', background: theme.colors.bgDark, padding: '20px' }} className="p-4">
      <div className="flex justify-between mb-4">
        <h2 className="text-2xl font-bold">Contrats</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setDrawerOpen(true)}
        >
          Ajouter un contrat
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={dummyData}
        pagination={false}
        className="border rounded-lg"
      />

      <Drawer
        title="Nouveau Contrat"
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={600}
      >
        <ContractForm />
      </Drawer>
    </div>
  );
};

export default YachtContract;
